import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { registerAppLocales } from './app/shared/configs/register-app-locales';

registerAppLocales();

bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));
